import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { legacy } from '@/shared/api/client';
import { FullPageLoader } from '@/shared/components/full-page-loader';
import { toast } from '@/shared/ui/toaster';

/**
 * Ponte de compatibilidade para links do Metabase / dash antigo:
 * `/multi-registration/edit/:leadId` → `/loja/:idPassbook/leads/:leadId`
 */
export function LegacyMultiRegistrationEditRedirect() {
  const { leadId } = useParams<{ leadId: string }>();
  const [target, setTarget] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!leadId) {
      setFailed(true);
      return;
    }

    let cancelled = false;

    void (async () => {
      try {
        const res = await legacy.get<{ user?: { id_passbooks?: string } }>(
          `/registration/${leadId}`,
        );
        const idPassbook = res.user?.id_passbooks ? String(res.user.id_passbooks) : '';
        if (cancelled) return;
        if (!idPassbook) {
          toast.error('Lead não encontrado', {
            description: 'Não foi possível resolver a loja deste lead.',
          });
          setFailed(true);
          return;
        }
        setTarget(`/loja/${idPassbook}/leads/${leadId}`);
      } catch {
        if (cancelled) return;
        toast.error('Lead não encontrado', {
          description: 'Não foi possível abrir o cadastro a partir do link legado.',
        });
        setFailed(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [leadId]);

  if (failed) return <Navigate to="/selecionar-loja" replace />;
  if (target) return <Navigate to={target} replace />;
  return <FullPageLoader />;
}
